/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Service } from 'services';

class DeploymentService extends Service {
  /**
   * Deploys the given diagram
   *
   * @param {String} diagramId
   * @param {Object} clusterInfo The info of the destination cluster
   * @param {Object} formResolutions A list of the form resolutions for the new deployment
   * @return {Promise}
   */
  deployDiagram(diagramId, clusterInfo, formResolutions) {
    return this.post(`/internal-api/files/${diagramId}/deploy`, {
      ...clusterInfo,
      formResolutions
    });
  }

  /**
   * Deploys the given process application
   *
   * @param {String} processApplicationId
   * @param {Object} clusterInfo The info of the destination cluster
   * @param {Object} formResolutions A list of the form resolutions for the new deployment
   * @return {Promise<import('services/ProcessApplicationService.common').ProcessApplicationDeployment>}
   */
  deployProcessApplication(processApplicationId, clusterInfo, formResolutions) {
    return this.post(`/internal-api/process-applications/${processApplicationId}/deploy`, {
      ...clusterInfo,
      formResolutions
    });
  }

  /**
   * Deploys the given process application version
   *
   * @param {String} processApplicationVersionId
   * @param {Object} clusterInfo The info of the destination cluster
   * @param {Object} formResolutions A list of the form resolutions for the new deployment
   * @return {Promise<import('services/ProcessApplicationService.common').ProcessApplicationDeployment>}
   */
  deployProcessApplicationVersion(processApplicationVersionId, clusterInfo, formResolutions) {
    return this.post(`/internal-api/process-application-versions/${processApplicationVersionId}/deploy`, {
      ...clusterInfo,
      formResolutions
    });
  }
}

export default new DeploymentService();
